import React from 'react'
import { Link } from 'react-scroll';
import './Navbar.css'
import { BsLinkedin, BsGithub } from 'react-icons/bs'
import { SiHackerrank } from 'react-icons/si'
import {FiSettings} from 'react-icons/fi'


export default function Navbar() {
  return (<>
    <div className='text-center' style={{backgroundColor:"rgb(175, 164, 164)"}}>Site Under Maintainance <FiSettings></FiSettings> </div>
    <div className="col-lg-12 col-md-12 sticky-top mx-auto nav_container" id='navbar'>
      <nav class="navbar navbar-expand-lg navbar-dark">

        <div class="container-fluid ">
          <Link class="navbar-brand my_name mx-lg-4" to='logo' >_PORTFOLIO_</Link>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse " id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0 mx-auto">
              <li class="nav-item mx-2">
                <Link to="home" spy={true} smooth={true} offset={-100} duration={500} class="" aria-current="page">Home</Link>
              </li>
              <li class="nav-item mx-2">
                <Link to="about" spy={true} smooth={true} offset={-100} duration={500} class="" aria-current="page">About</Link>
              </li>
              <li class="nav-item mx-2">
                <Link to="services" spy={true} smooth={true} offset={-60} duration={500} class="" aria-current="page">Services</Link>
              </li>
              <li class="nav-item mx-2">
                <Link to="skill" spy={true} smooth={true} offset={-100} duration={500} class="" aria-current="page">Skills</Link>
              </li>
              <li class="nav-item mx-2">
                <Link to="projects" spy={true} smooth={true} offset={-250} duration={500} class="" aria-current="page">Projects</Link>
              </li>
              <li class="nav-item mx-2">
                <Link to="reviews" spy={true} smooth={true} offset={-120} duration={500} class="" aria-current="page">Reviews</Link>
              </li>
              <li class="nav-item mx-2">
                <Link to="contact" spy={true} smooth={true} offset={-100} duration={500} class="" aria-current="page">Contact Me</Link>
              </li>
            </ul>
            <li class="nav-item mx-3">
              <h1>
                <a href="https://www.linkedin.com/in/qazi-zohaib-ali-799824245/" target="_blank" rel="noreferrer"><BsLinkedin></BsLinkedin></a>

              </h1>
            </li>
            <li class="nav-item mx-3">
              <h1>
                <a href="https://github.com/qazizohaibali" target="_blank" rel="noreferrer"> <BsGithub></BsGithub></a>


              </h1>
            </li>
            <li class="nav-item mx-3">
              <h1>
                <a href="https://www.hackerrank.com/qazizohaibali3" target="_blank" rel="noreferrer"><SiHackerrank></SiHackerrank></a>


              </h1>
            </li>





          </div>
        </div>

      </nav>



    </div>



  </>
  )
}
